import { Spoke } from '@statsbomb/kitbag-datavis';

export const SpokeIcon = ({ numberOfSpokes, spokeIndex }: { numberOfSpokes: number; spokeIndex: number }) => (
  <div className="w-4 h-4 flex" aria-hidden="true">
    <Spoke numberOfSpokes={numberOfSpokes} spokeIndex={spokeIndex} />
  </div>
);
